// src/pages/SettingsPage.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function SettingsPage() {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({});
  const [formValues, setFormValues] = useState({});
  const [message, setMessage] = useState(null);

  useEffect(() => {
    async function fetchSettings() {
      try {
        const resp = await api.get('/settings');
        setSettings(resp.data);
        setFormValues(resp.data);
      } catch (err) {
        console.error('Failed to load settings:', err);
      }
    }
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    try {
      // Sending whatever fields the admin has set, including UPIId which may be null or ''
      await api.put('/settings', formValues);
      setMessage('Settings updated successfully');
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || 'Update failed');
    }
  };

  return (
    <div className="form-container">
      <button
        className="btn-back"
        onClick={() => navigate(-1)}
        style={{
          background: 'none',
          border: 'none',
          color: '#555',
          cursor: 'pointer',
          marginBottom: '1rem',
          fontSize: '0.9rem',
          textDecoration: 'underline',
        }}
      >
        ← Back
      </button>

      <h2 style={{ textAlign: 'center' }}>Settings</h2>

      {message && (
        <div className="message" style={{ marginBottom: '1rem', color: '#2f8132' }}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Name</label>
          <input
            name="HotelName"
            value={formValues.HotelName || ''}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Address</label>
          <textarea
            name="HotelAddress"
            value={formValues.HotelAddress || ''}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Phone</label>
          <input
            name="HotelPhone"
            value={formValues.HotelPhone || ''}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>UPI ID (optional)</label>
          <input
            name="UPIId"
            placeholder="e.g. 7406960614@ybl"
            value={formValues.UPIId ?? ''}
            onChange={handleChange}
          />
        </div>

        <button type="submit" style={{ marginTop: '1rem' }}>
          Save
        </button>
      </form>
    </div>
  );
}
